import React from "react";
// import ReactDOM from "react-dom";
import { TokenAnnotator } from "react-text-annotate";

import "./styles.css";

const TAG_COLORS = {
    ORG: "#00ffa2",
    PERSON: "#84d2ff"
};

const Card = ({ children }) => (
    <div
        style={{
            boxShadow: "0 2px 4px rgba(0,0,0,.1)",
            margin: 6,
            maxWidth: 500,
            padding: 16
        }}
    >
        {children}
    </div>
);

class Tagger extends React.Component {
    state = {
        TEXT: this.props.text,
        inputTag: '',
        value: [
        ],
        tag: "PERSON",
        tags: ["person", "organisation"]

    };

    handleChange = value => {
        this.setState({ value });
    };

    handleAllTags = () => {
        var tagging = this.state.tags
        if (!tagging.includes(this.state.inputTag) && this.state.inputTag) {
            tagging.push(this.state.inputTag)
            this.setState({ tags: tagging})
            this.setState({inputTag:''})
        }
    }

    handleTagChange = e => {
        this.setState({ tag: e.target.value });
    };

    exportData = () => {
        const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
            JSON.stringify(this.state.value)
        )}`;
        const link = document.createElement("a");
        link.href = jsonString;
        link.download = "data.json";

        link.click();
    };

    render() {
        console.log(this.state.inputTag)
        return (
            <div style={{ padding: 24, fontFamily: "IBM Plex Sans" }}>
                <input value={this.state.inputTag} onChange={(e) => this.setState({ inputTag: e.target.value })}></input>
                <button onClick={this.handleAllTags}>Add tags</button>
                <div style={{ display: "flex", marginBottom: 24 }}>
                    <Card>
                        <h4>Custom rendered mark</h4>
                        <select onChange={this.handleTagChange}>
                            {this.state.tags.map(ele => {
                                return (
                                    <option value={ele}>{ele}</option>
                                )
                            })}
                        </select>
                        <TokenAnnotator
                            style={{
                                maxWidth: 500,
                                lineHeight: 1.5
                            }}
                            tokens={this.state.TEXT.split(" ")}
                            value={this.state.value}
                            onChange={this.handleChange}
                            getSpan={span => ({
                                ...span,
                                tag: this.state.tag,
                                color: TAG_COLORS[this.state.tag]
                            })}
                            renderMark={props => (
                                <mark
                                    key={props.key}
                                    onClick={() =>
                                        props.onClick({
                                            start: props.start,
                                            end: props.end,
                                            text: props.text,
                                            tag: props.tag,
                                            color: props.color
                                        })
                                    }
                                    style={{
                                        padding: ".2em .3em",
                                        margin: "0 .25em",
                                        lineHeight: "1",
                                        display: "inline-block",
                                        borderRadius: ".25em",
                                        background: "#a6e22d"
                                    }}
                                >
                                    {props.content}{" "}
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            content: "attr(data-entity)",
                                            fontSize: ".55em",
                                            lineHeight: "1",
                                            padding: ".35em .35em",
                                            borderRadius: ".35em",
                                            textTransform: "uppercase",
                                            display: "inline-block",
                                            verticalAlign: "middle",
                                            margin: "0 0 .15rem .5rem",
                                            background: "#fff",
                                            fontWeight: "700"
                                        }}
                                    >
                                        {" "}
                                        {props.tag}
                                    </span>
                                </mark>
                            )}
                        />
                    </Card>
                </div>
                <Card>
                    <h4>Current Value</h4>      <button type="button" onClick={this.exportData}>
                        Export Data
                    </button>
                    {/* <pre>{JSON.stringify(this.state.value, null, 2)}</pre> */}
                </Card>
            </div>
        );
    }
}


export default Tagger;